/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import './src/scss/global.scss'

const shouldUpdateScroll = ({
  prevRouterProps,
  routerProps,
  getSavedScrollPosition,
}) => {
  const regex = /\/faq|\/resources/

  if( routerProps.location.pathname.search( regex ) !== -1 && prevRouterProps.location.pathname.search( regex ) !== -1 ) {
    const prevPosition = getSavedScrollPosition( prevRouterProps.location )

    window.scrollTo( ...( prevPosition || [ 0, 0 ] ) )

    return false
  }
}

export {
  shouldUpdateScroll
}